export default {
  getProvider() {
    return require('./doubleClickProvider').DoubleClickProvider
  },
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/ads/providerFactory.js